import styled from "styled-components";
import { media } from "../../themes";

const defaultMargin = "0.25em";

const getTextColor = hex => {
    if (!hex) return null;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.55 ? "#333333" : "#ffffff";
};

const StyledChoice = styled.button`
    border: 3px solid ${props => props.bgColor || props.theme.colours.flat.darkGray.hex};
    color: ${props => (props.bgColor ? getTextColor(props.bgColor) : props.theme.colours.flat.darkGray.hex)};
    background-color: ${props => props.bgColor || props.theme.colours.flat.white.hex};
    margin: ${() => {
        return defaultMargin;
    }};
    padding: 0.8em 1.2em;
    font-size: ${props => props.fontSize || props.theme.text.heading4.sizeRem};
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: ${props => props.theme.defaults.borderRadius};
    width: ${props => props.width};
    min-height: 3.5em;
    overflow: hidden;
    text-align: center;

    ${media.mobile`
        width: 90%;
    `}

    @media(hover: hover) {
        :hover {
            background: ${props => props.theme.colours.flat.blue.hex};
            color: #fff;
            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
            border: 3px solid ${props => props.theme.colours.flat.blue.hex};
            width: ${props => props.width};
        }
    }

    :active {
        background: ${props => props.theme.colours.flat.darkBlue.hex};
        border: 3px solid ${props => props.theme.colours.flat.darkBlue.hex};
        color: ${props => props.theme.colours.flat.white.hex};
        box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.25);
        width: ${props => props.width};
    }

    :focus {
        outline: none;
    }

    height: inherit;
`;

const StyledChoiceSelected = styled(StyledChoice)`
    background: ${props => props.theme.colours.flat.darkBlue.hex};
    border: 3px solid ${props => props.theme.colours.flat.darkBlue.hex};
    color: ${props => props.theme.colours.flat.white.hex};
    box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.25);
    ${media.mobile`
        width: 90%;
    `}
`;

export { StyledChoice, StyledChoiceSelected };
